<script lang="ts">
	import ShutterInside from "./ShutterInside.svelte";
	import type { Shutter } from "../scripts/classes/page";
    import SubShutter from "./SubShutter.svelte";
    import Contact from "./Contact.svelte";
    import { onMount } from "svelte";

	export let inShutter = {
		shutter: <Shutter>{},
		radius: false,
		isContact: false
    }

	let isOpen: boolean = false;

	onMount(async () => {
		if (inShutter.shutter.title == "L’offre nationale du dispositif") {
			isOpen = true;
		}
	});

	function toogleIsOpen() {
		isOpen = !isOpen;
	}

</script>

<style lang="scss">
	.shutter {
		position: relative;
		z-index: 1;
		width: 110%;
		min-width: 110%;
		margin-left: -5%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border: 1px solid $color_black;
		background-color: $color_white;
		padding: 20px 0px 20px 0px;
		box-sizing: border-box;
		&__open {
			height: auto;
		}
		&__radius {
			border-radius: 45px;
			&__contact {
				border-radius: 41px;
			}
		}
		&__header {
			cursor: pointer;
			width: 90%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			&__left {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				align-items: flex-start;
				&__title {
					font-family: 'Borna-Bold';
					font-size: 14px;
					margin: 0 0 0 0;
				}
				&__text {
					display: none;
					font-family: 'Borna-Medium';
					font-size: 14px;
					&__open {
						display: block;
					}		
				}
			}
			&__right {
				width: 20%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: flex-end;
				align-self: flex-start;
				&__deploybtn {
					background-image: url('../assets/images/btn_plus.svg');
					width: 40px;
					height: 40px;
					&__open {
						background-image: url('../assets/images/btn_moins.svg');
					}
				}
			}
		}
		&__content {
			display: none;
			&__open {
				width: 90%;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}
		}
		&__contacts {
			display: none;
			&__open {
				height: 100%;
				width: 90%;
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				align-items: flex-start;
				flex-wrap: wrap;
			}
		}
		&__contact {
			width: 43%;
			margin: 0 18px 0 0;
		}
	}

	.shutter-110 {
		position: relative;
		z-index: 0;
		opacity: 0;
		height: 0;
		word-wrap: break-word;
		width: 110%;
		min-width: 110%;
		margin-left: -5%;
	}

	@include large {
		.shutter-110 {
			display: none;
		}
		.shutter {
			width: 100%;
			max-height: 190px;
			height: 190px;
			min-width: auto;
			margin-left: 0;
			padding: 30px 90px 30px 90px;
			&:hover {
				background-color: $color_primary;
			}
			&__open {
				height: auto;
				max-height: none;
				padding: 30px 90px 60px 90px;
				&:hover {
					background-color: $color_white;
				}
			}
			&__radius {
				border-radius: 95px;
			}
			&__header {
				width: 100%;
				align-items: center;
				&__left {
					width: 80%;
					&__title {
						font-size: 1.4vw;
						margin: 0 0 10px 0;
					}
					&__text {
						overflow: hidden;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						-webkit-box-orient: vertical;
						font-size: 1.2vw;
						&__open {
							display: block;
						}		
					}
				}
				&__right {
					align-self: inherit;
					&__deploybtn {
						width: 60px;
						height: 60px;
						&__open {
							&:hover {
								background-image: url('../assets/images/btn_moins_hover.svg');
							}
						}
					}
				}
			}
			&__content {
				&__open {
					width: 100%;
				}
			}
			&__contacts {
				&__open {
					flex-wrap: wrap;
					width: 100%;
				}
			}
			&__contact {
				width: 21%;
				margin: 0 25px 0 0;
			}
		}
	}

	@include xlarge {
		.shutter {
			&__header {
				&__left {
					&__title {
						font-size: 21px;
					}
					&__text {
						font-size: 19px;
					}
				}
			}
		}
	}

</style>

<div class="shutter-110">A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A A </div>
<div class="shutter" class:shutter__radius={inShutter.radius} class:shutter__radius__contact={inShutter.isContact && inShutter.radius} class:shutter__radius__open={inShutter.radius && isOpen} class:shutter__open={isOpen}>
	<div class="shutter__header" on:click={toogleIsOpen} on:keydown={toogleIsOpen}>
		<div class="shutter__header__left">
			<div class="shutter__header__left__title">{inShutter.shutter.title}</div>
			<div class="shutter__header__left__text" class:shutter__header__left__text__open={isOpen}>{@html inShutter.shutter.text}</div>	
		</div>
		<div class="shutter__header__right">
			<div class="shutter__header__right__deploybtn" class:shutter__header__right__deploybtn__open={isOpen}></div>
		</div>	
	</div>
	<div class="shutter__content" class:shutter__content__open={isOpen}>
		{#each inShutter.shutter.subshutters as subshutter}
		{#if subshutter.type == 2}
			<SubShutter inSubShutter={subshutter} />
		{:else if subshutter.type > 2}
			<ShutterInside inShutterInside={{nbColumn: subshutter.type - 2, title: subshutter.subtitle, text: subshutter.text}} />
		{/if}
		{/each}
	</div>
	<div class="shutter__contacts" class:shutter__contacts__open={isOpen}>
		{#each inShutter.shutter.contacts as contact}
		<div class="shutter__contact">
			<Contact inContact={contact} />
		</div>
		{/each}
	</div>
</div>
